import { useLocation, useMatches } from 'react-router-dom';
import { useGetAgendaByIdQuery } from 'store/services/flow/agenda';
import { useGetTemplateByIdQuery } from 'store/services/helios/templates';
import { isValidId } from 'utils/object';

export const useTemplateIdToModuleId = (): string | undefined => {
  const matches = useMatches();
  const location = useLocation();
  const isHelios = location.pathname.includes('/admin/helios/templates/');
  const isFlow = location.pathname.includes('/admin/flow/modules&agendas/');
  const routeParams = matches[matches.length - 1]?.params;
  const templateId = isFlow ? (routeParams?.agendaId ?? routeParams?.id) : isHelios ? routeParams?.id : undefined;
  const validTemplateId = isValidId(templateId) ? templateId : undefined;
  let moduleId: string | undefined;

  const { data: heliosTemplate, isError: isHeliosTemplateError } = useGetTemplateByIdQuery(
    { id: validTemplateId ?? '', suppressErrorToast: true },
    { skip: !validTemplateId || !isHelios }
  );
  const { data: flowAgenda, isError: isFlowAgendaError } = useGetAgendaByIdQuery(
    { id: validTemplateId ?? '', suppressErrorToast: true },
    { skip: !validTemplateId || !isFlow }
  );

  if ((isHelios && isHeliosTemplateError) || (isFlow && isFlowAgendaError)) {
    return undefined;
  }

  if (isHelios && validTemplateId) {
    if (heliosTemplate?.moduleId) {
      moduleId = heliosTemplate.moduleId;
    }
  }
  if (isFlow && validTemplateId) {
    if (flowAgenda?.module?.id) {
      moduleId = flowAgenda.module.id;
    }
  }

  return moduleId;
};
